module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAAAECAYAAAAgaQkXAAAAmUlEQVQ4T+2T0Q3CMAxEL0xBR4I1kNiK8aAMQf1QYpsG1A/6n48o53N8tk5OAU6gm0kTSEgy/NS44Y7L3JI5pIYt7oh7ruIl8omrzocz7+OafOuZx/6Wrib5H86kV77razZ0Wq+cy1hnCOwzOb96YbPscCnAAzRVc4ZxuQRu1qZxIGAexu3duGacntW4c3zV49i4vzbuTinXNz+rpbNWEapGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/assessLeft.png
// module id = 2FVY
// module chunks = 1